const rotatingFeatureSection = document.querySelectorAll('.rotating-feature-section');

rotatingFeatureSection.forEach(section => {
    const features = section.querySelectorAll('.feature');
    const randomlyGeneratedIndex = Math.floor(Math.random() * features.length);
    for (let i = 0; i < features.length; i++) {
        if (i == randomlyGeneratedIndex) {
            features[i].classList.add('visible');
        } else {
            features[i].remove();
        }
    }
})